import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { onLabsCanvasOpened } from '../gaEvents'
import { hasCanvasWorkspace, openProductionChartInCanvas } from './canvasWorkspace'
import styles from './OpenInCanvasButton.module.scss'

/** A production-workflow action that hands the current chart to Canvas. */
export default function OpenInCanvasButton({
  chart,
  dataset,
  dataTypes,
  mapping,
  visualOptions,
  brandTheme,
  datasetName,
}) {
  const canOpen = Boolean(chart && Array.isArray(dataset) && dataTypes)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [opening, setOpening] = useState(false)
  const [openError, setOpenError] = useState(null)
  const snapshot = { chart, dataset, dataTypes, mapping, visualOptions, brandTheme, datasetName }
  const openLab = async () => {
    setOpening(true)
    setOpenError(null)
    const replacesWorkspace = hasCanvasWorkspace()
    onLabsCanvasOpened(chart?.metadata?.id, replacesWorkspace)
    try {
      await openProductionChartInCanvas(snapshot)
    } catch (error) {
      setOpening(false)
      setOpenError(error?.message || 'Canvas could not save this dataset in this browser.')
    }
  }

  const handleOpen = () => {
    if (hasCanvasWorkspace()) {
      setConfirmOpen(true)
      return
    }
    openLab()
  }

  return <>
    <button
      type="button"
      className={styles.button}
      disabled={!canOpen || opening}
      onClick={handleOpen}
    >
      {opening ? 'Opening Canvas…' : 'Open in Lugsail Labs'}
    </button>
    {openError && <p className="text-danger mt-2 mb-0" role="alert">{openError}</p>}
    <Modal centered show={confirmOpen} onHide={() => setConfirmOpen(false)}>
      <Modal.Header closeButton>
        <Modal.Title as="h5">Open in Lugsail Labs?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Lugsail Labs is an experimental canvas for comparing chart versions
          side by side. Your current chart will open there with its data,
          mappings, and styling.
        </p>
        <p className="mb-0">
          This will replace the current Labs board. It will not change this
          Lugsail project.
        </p>
        {openError && <p className="text-danger mt-3 mb-0">{openError}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={() => setConfirmOpen(false)} disabled={opening}>
          Keep current board
        </Button>
        <Button variant="primary" onClick={openLab} disabled={opening}>
          {opening ? 'Opening Canvas…' : 'Replace Labs board'}
        </Button>
      </Modal.Footer>
    </Modal>
  </>
}
